// Login.js
import React, { useState } from 'react';
import { Container, Title, Input, Button, ErrorMessage } from '../styles.js'; 
import { auth } from '../../../config/firebase.js'; 
import { signInWithEmailAndPassword } from 'firebase/auth'; 
import { useNavigate } from 'react-router-dom';
import Load from '../../../components/load/index.js';
import { getErroMessage } from '../messages-erro.js';

const Login = ({ loadingUser }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const uid = userCredential.user.uid;
      navigate('/profiles');
    } catch (error) {
      console.error('Erro ao fazer login:', error);
      getErroMessage(error.code, setError);
      setTimeout(() => {
        setError('');
      }, 5000);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container>
      {loadingUser || isLoading ? (
        <Load />
      ) : (
        <>
          <Title>Login</Title>
          <form onSubmit={handleLogin}>
            <label htmlFor="email">Email</label>
            <Input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <label htmlFor="password">Senha</label>
            <Input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <Button type="submit">Login</Button>{error && <ErrorMessage><i className='fas fa-exclamation-triangle'></i> {error}</ErrorMessage>}
          </form>
        </>
      )}
    </Container>
  );
};

export default Login;
